import { Suspense, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import GRSConference from "../routes/grs-routes";
import Footer from "../components/footer/footer";
import { useAppDispatch } from "../redux/store";
import { retrieveNotification } from "../redux/slice/notification-slice";
import LoadingComp from "../components/re-usable/loading/loading";
import GRSConferenceHeader from "../components/header/grs-header";
import ConferenceLayoutStyleComponent from "./components/eucrm-layout-style.component";

const GRSConferenceLayout = () => {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(retrieveNotification())
  })
  return (
    <>
      <ConferenceLayoutStyleComponent />
      <div>
        <GRSConferenceHeader />
        <Suspense fallback={<LoadingComp />}>
          <Routes>
            {GRSConference.map((route, index) => {
              return route.component ? <Route key={index} path={route.path} element={route.component} /> : null;
            })}
          </Routes>
        </Suspense>
        <Footer />
      </div >
    </>
  );
};

export default GRSConferenceLayout;